import { Vue, Watch } from 'vue-property-decorator';
import { bus } from './main';

export default class GlobalMixins extends Vue {
	nextButtonDisabled: boolean = false
	answer: any = false

	get question() {
		if (this.$route.name !== 'question') return

		return JSON.parse(JSON.stringify(this.$store.getters.questions[JSON.parse(this.$route.params.questionId) - 1]))
	}

	@Watch('answer', { deep: true })
	onAnswerChange(): void {
		if (!this.answer) bus.$emit('setQuestionNextButton', false)

		switch(this.question.type) {
			case 'word-cloud':
			case 'panels':
					bus.$emit('setQuestionNextButton', this.answer.length > 0)
				break
			case 'image-comparison':
				bus.$emit('setQuestionNextButton', this.answer.length === this.question.choices.length)
				break
			case 'word-cloud-multiple':
				let allCloudsHaveAnswers = true

				;[...this.answer].forEach((cloud: string[]) => {
					if (cloud.length < 1) allCloudsHaveAnswers = false
				})

				bus.$emit('setQuestionNextButton', allCloudsHaveAnswers)				
				break
			case 'versus':
				let allOptionsSelected = true

				;[...this.answer].forEach((option: string | null) => {
					if (!option) allOptionsSelected = false
				})

				bus.$emit('setQuestionNextButton', allOptionsSelected)				
				break
			case 'terms':
				let termsFilledIn = true

				if (!this.answer) termsFilledIn = false
				if (!this.answer.salary) termsFilledIn = false
				if (!this.answer.salary.min || this.answer.salary.min < this.question.salary.min) termsFilledIn = false
				if (!this.answer.salary.max || this.answer.salary.min > this.question.salary.max) termsFilledIn = false
				if (!this.answer.hours) termsFilledIn = false
				if (!this.answer.hours.min || this.answer.hours.min < this.question.hours.min) termsFilledIn = false
				if (!this.answer.hours.max || this.answer.hours.min > this.question.hours.max) termsFilledIn = false
				if (!this.answer.car) termsFilledIn = false
				
				bus.$emit('setQuestionNextButton', termsFilledIn)
				break
			case 'feedback':
				bus.$emit('setQuestionNextButton', true)
				break
			default:
				bus.$emit('setQuestionNextButton', false)
				break
		}
		
		this.updateEntityTestValues()
	}

	optionSelected(option: any, questionType: string): boolean {
		if (!this.answer) return false

		if (questionType === 'word-cloud-multiple') {
			let optionAmongClouds = false

			;[...this.answer].forEach((cloud: string[]) => {
				if (cloud.indexOf(option) !== -1) optionAmongClouds = true
			})

			return optionAmongClouds
		} else {
			return this.answer.indexOf(option) !== -1
		}
	}
	sluggedTitleOfQuestion(titleObject: string | {'User': string, 'Client': string}): string {
		if (typeof titleObject === 'string') {
			return this.slugify(titleObject)
		} else {
			return this.slugify(titleObject[(<'User' | 'Client'>this.$store.getters.entityType)])
		}
	}
	validateEmail(email: string): boolean {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
	}
	phoneContainsLetters(phone: string) {
		return RegExp(/[A-Za-z]/).test(phone)
	}
	slugify(string: string): string {
		const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
		const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
		const p = new RegExp(a.split('').join('|'), 'g')
		
		return string.toString().toLowerCase()
			.replace(/\s+/g, '-')
			.replace(p, c => b.charAt(a.indexOf(c)))
			.replace(/&/g, '-and-')
			.replace(/[^\w\-]+/g, '')
			.replace(/\-\-+/g, '-')
			.replace(/^-+/, '')
			.replace(/-+$/, '')
	}
	toPreviousScreen() {
		const currentRouteName = this.$route.name

		if (currentRouteName === 'start') return
		if (currentRouteName === 'entityData') this.$router.push({ name: 'start', params: { id: this.$store.getters.entity.id } })
		if (currentRouteName === 'question') {
			if ((JSON.parse(this.$route.params.questionId) - 1) === 0) {
				this.$router.push({ name: 'entityData' })
			} else {
				const questions = this.$store.getters.questions

				this.$router.push({ name: 'question', params: { questionId: JSON.stringify(JSON.parse(this.$route.params.questionId) - 1), title: this.sluggedTitleOfQuestion(questions[JSON.parse(this.$route.params.questionId) - 2].title) }})
			}
		}
		if (currentRouteName === 'thanks') {
			const questions = this.$store.getters.questions

			this.$router.push({ name: 'question', params: { questionId: JSON.stringify(questions.length), title: this.sluggedTitleOfQuestion(questions[questions.length - 1].title) }})
		}
	}
	toNextScreen() {
		if (this.nextButtonDisabled || !this.$store.getters.privacyStatementSelected) return

		const questions = this.$store.getters.questions

		if (this.$route.name === 'entityData') {
			this.$router.push({ name: 'question', params: { questionId: '1', title: this.sluggedTitleOfQuestion(questions[0].title) }})
		} else if(JSON.parse(this.$route.params.questionId) === questions.length) {
			this.$router.push({ name: 'thanks' })
		} else {
			this.$router.push({ name: 'question', params: { questionId: JSON.stringify(JSON.parse(this.$route.params.questionId) + 1), title: this.sluggedTitleOfQuestion(questions[JSON.parse(this.$route.params.questionId)].title) }})
		}
	}
	setAnswer(emptyValue: any): void {
		if (this.$route.name !== 'question') return

		const questionIndex = (JSON.parse(this.$route.params.questionId) - 1)
		const testValues = this.$store.getters.entityTestValues

		if (testValues) {
			if (testValues[questionIndex]) {
				this.answer = testValues[questionIndex]
			} else {
				this.answer = emptyValue
			}
		} else {
			this.answer = emptyValue
		}
	}
	updateEntityTestValues(): void {
		if (this.$route.name !== 'question') return

		const questionIndex = (JSON.parse(this.$route.params.questionId) - 1)
		const currentTestValues = this.$store.getters.entityTestValues
		let newTestValues = currentTestValues

		newTestValues[questionIndex] = this.answer

		this.$store.dispatch('updateEntity', {
			testValues: JSON.stringify(newTestValues)
		})
	}
}
